import React from "react"

import type { MetricRecord } from "@/metrics/runtime"

import { useConversationsSummaryPublisher } from "../hooks/useConversationsSummaryPublisher"

interface ConversationsSummaryPublisherProps {
  enabled?: boolean
  metricDisplayNames?: Record<string, string>
  metricRecordsById?: Record<string, MetricRecord | undefined>
}

/**
 * Renders nothing: the conversations summary lives in the Sofia chat, not in the
 * page body. Kept as a memoized component rather than a hook
 * call inside `ConversationsTable` so that the summary query settling
 * re-renders only this leaf instead of the whole table.
 */
export const ConversationsSummaryPublisher = React.memo(
  ({
    enabled = true,
    metricDisplayNames,
    metricRecordsById,
  }: ConversationsSummaryPublisherProps) => {
    useConversationsSummaryPublisher({
      enabled,
      metricDisplayNames,
      metricRecordsById,
    })

    return null
  },
)

ConversationsSummaryPublisher.displayName = "ConversationsSummaryPublisher"
